export default ({ color, typography, fontSize }) => ({
  dashboard: {
    backgroundColor: color.uiBackground,
    color: color.bodyText,
    fontFamily: typography.bodyText,
    margin: 'auto',
    paddingLeft: 36,
    paddingRight: 36,
    paddingTop: '30px',
    paddingBottom: '14vh',
  },

  dashboardContainer: {
    marginLeft: 36,
    marginRight: 36,
  },

  printchart: {
    '@media print': {
      pageBreakAfter: 'always',
      width: '96%',
      marginLeft: '2%',
    },
  },

  printfiltersummary: {
    display: 'none',
    '@media print': {
      fontSize: fontSize.smallText,
      fontFamily: typography.bodyText,
      fontStyle: 'normal',
      fontWeight: 'normal',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'start',
      marginBottom: 24,
    },
  },

  printdataContainer: {
    '@media print': {
      width: '75%',
    },
  },

  printdatafilterelem: {
    '@media print': {
      marginBottom: 4,
    },
  },

  printdateContainer: {
    '@media print': {
      textAlign: 'right',
      width: '20%',
    },
  },

  printdatefilter: {
    '@media print': {
      textAlign: 'right',
    },
  },

  chart: {
    marginTop: '10px',
    width: 1100,
    height: 419,
    border: 'none',
    background: 'rgb(228, 228, 228)',
  },

  chartLabel: {
    fontWeight: 700,
    fontSize: 28,
  },

  chartBox: {
    marginTop: 40,
    width: '100%',
  },

  dashboardLabelContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'start',
    fontSize: 25,
    fontFamily: typography.siteTitle,
    marginBottom: 20,
  },

  exportBtnContainer: {
    '@media print': {
      display: 'none',
    },
  },

  exportBtn: {
    backgroundColor: `${color.primaryButtonBackground} !important`,
    borderColor: `${color.primaryButtonBackground} !important`,
    color: `${color.primaryButtonText} !important`,
    fontFamily: `${typography.bodyText} !important`,
    fontSize: `${fontSize.buttonText} !important`,
    fontWeight: 'normal !important',
    '&:hover': {
      backgroundColor: `${color.primaryButtonHover} !important`,
      borderColor: `${color.primaryButtonHover} !important`,
    },
  },

  globalFilters: {
    marginTop: 40,
  },

  globalFiltersBox: {
    width: 265,
    height: 45,
    border: '1px solid  rgb(199, 195, 195)',
    margin: '10px 10px 0px 0px',
    display: 'inline-block',
    backgroundColor: '#ffffff',
    borderRadius: 5,
  },

  globalFiltersLabel: {
    fontSize: 28,
    fontWeight: 700,
    display: 'block',
  },

  globalFiltersText: {
    padding: '5% 0',
    textAlign: 'center',
  },

  defaultLine: {
    backgroundColor: 'rgb(199, 198, 198)',
    width: 1100,
    height: 1,
    marginTop: 5,
  },
  dashboardLabelTitle: {
    color: color.pageTitle,
    fontFamily: typography.pageTitle,
    fontSize: fontSize.pageTitle,
  },
  placeholderText: {
    color: color.bodyText,
    fontFamily: typography.bodyText,
    fontSize: fontSize.bodyText,
  },
  report: {
  },
});